<template>
  <div class="right-card">
    <div class="right-card-title">
      <slot name="title" />
      {{ props.title }}
    </div>
    <div class="right-card-main"><slot /></div>
  </div>
</template>

<script setup lang="ts">
interface CardData {
  title: string;
}
const props = withDefaults(defineProps<CardData>(), {
  title: '',
});
</script>

<style lang="scss">
.cert-list-page {
  .right-card {
    width: 240px;
    padding: 20px 13px 0;
    border-radius: 8px;
    margin-bottom: 20px;
    background-color: #ffffff;
    box-shadow: 0px 0px 20px 0px rgba(44, 70, 137, 0.06);

    .right-card-title {
      color: #333333;
      font-size: 16px;
      font-weight: bold;
      line-height: 1;
    }
  }
}
</style>
